
import { useState } from "react";
import ProductAccessory from './productAccessory'
import { ReactComponent as Arrow } from '../../../../assets/icons/arrow.svg';
import i18n from '../../../../utils/translations/i18n';
import './index.scss';
import { cartInteractionEvent } from "../../../../utils/analytics/google";
import { CartInteraction } from "../../../../enums/cartInteraction";
import Lineitem from "../../../../models/lineitem";
  
  const Accessory = ({ cart, lineItemId, accessoryData, mainItem }: {cart: any, lineItemId: string, accessoryData: any, mainItem:any}) => {
    const [isProductAccessoryOpen, setIsProductAccessoryOpen] = useState(false);
    const toggleButton = () => {
      if (!isProductAccessoryOpen) {
        cartInteractionEvent(
            CartInteraction.ACCESSORY_EXPAND,
            mainItem?.webCode || mainItem?.productFamilyName
        );
      }
      setIsProductAccessoryOpen(!isProductAccessoryOpen);
    }
    const { t } = i18n;

  return (
    <div className={`shopping-bag__extra-items ${isProductAccessoryOpen ? 'is-open' : 'is-closed'}`}>
        <div className='heading-container' onClick={toggleButton}>
            <Arrow className={`arrow ${isProductAccessoryOpen ? 'rotate' : ''}`} />
            <span className='add-acc-msg'>{t('shopping_cart_details.add_accessory')}</span>
        </div>
        {isProductAccessoryOpen &&
          <div className="toggle__content">
            <ul className="extra-items base">
              <ProductAccessory cart={cart} lineItemId={lineItemId} productAccessory={accessoryData}/>
            </ul>
          </div>
        }
    </div>
  )
}

export default Accessory;